module.exports = __webpack_public_path__ + "media/images/features/7/feature-7-item-option-b4405e565b4e0c0b14e35af571d09745.png";